import { render, staticRenderFns } from "./VacanciesBannerBlock.vue?vue&type=template&id=4daa43c8&scoped=true&"
import script from "./VacanciesBannerBlock.vue?vue&type=script&lang=js&"
export * from "./VacanciesBannerBlock.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesBannerBlock.vue?vue&type=style&index=0&id=4daa43c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daa43c8",
  null
  
)

export default component.exports